import React, { useEffect, useState } from 'react'
import { postConsentimientoInformadoPrincipal } from '../../services/PaginaRuta'
import { fechaActual } from '../../hooks/UseDate'
import TablaConsentimientoInformadoPrincipal from './TablaConsentimientoInformadoPrincipal';
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../services/ApiHIS';
import Loading from '../Loading';

const PrincipalConsentimientoInformado = () => {
    //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [dataConsentimientoInformado, setdataConsentimientoInformado]=useState([])
    const [loading, setloading]=useState(true)
    const [actualizarData, setactualizarData]=useState('')
    const [fechaInicial, setfechaInicial]=useState(fechaActual())
    const [fechaFinal, setfechaFinal]=useState(fechaActual())

    //token
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const tokenCons = JSON.parse(query.get('token'));
  //localStorage.removeItem('tokenReact');
  //localStorage.setItem('tokenReact',tokenCons)
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
    console.log(tokenCons,' tokenCons')
  }, [location]);

  //token
  const token=()=>{
  
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL()
 
    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };
 

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      //console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      //console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  }

    useEffect(()=>{
        token()
        const filtro={
            'TFFchI': fechaInicial,
            'TFFchF': fechaFinal,
            //"SCCCod": usuarioInfo.Sede,
            //"SccEmp": usuarioInfo.Empresa, 
            "TFTDoc": '',
            "TFCedu": '',
            "MPNOMC": '',
            "ClaPro": '',
            "salida": '',
            "TFcCodPab": '',
        }
        setloading(false)
        postConsentimientoInformadoPrincipal(filtro).then((res)=>{
            setloading(true)
            //console.log(res.data, 'data consentimientoss')
            setdataConsentimientoInformado(res.data)
        })
    },[actualizarData])

    const handleOnsubmitBuscar=(e)=>{
        e.preventDefault()
        const filtro={
            'TFFchI': fechaInicial,
            'TFFchF': fechaFinal,
            //"SCCCod": usuarioInfo.Sede,
            //"SccEmp": usuarioInfo.Empresa, 
            "TFTDoc": '',
            "TFCedu": e.target.userId.value,
            "MPNOMC": '',
            "ClaPro": '',
            "salida": '',
            "TFcCodPab": '',
        }
        setloading(false)
        postConsentimientoInformadoPrincipal(filtro).then((res)=>{
            setloading(true)
            //console.log(res.data, 'data consentimientoss')
            setdataConsentimientoInformado(res.data)
        })
    }

    const handleOnchangeFechaInicial=(e)=>{
      setfechaInicial(e.target.value)
    }

    const handleOnchangeFechaFinal=(e)=>{
      setfechaFinal(e.target.value)
    }
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
        Consentimiento informado
        </div>
        

        <form onSubmit={handleOnsubmitBuscar}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                N° documento identidad
              </label>
              <div className="flex">
                <input
                  name="userId"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-sm font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div className="mb-3 pl-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Fecha inicial
              </label>
              <div className="flex">
                <div className="flex items-center justify-center">
                  <div className="datepicker relative form-floating mb-3 xl:w-96">
                    <input
                      onChange={handleOnchangeFechaInicial}
                      value={fechaInicial}
                      type="date"
                      name="dateInicial"
                      className="form-control block w-full px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder="Select a date"
                    />
                  </div>
                </div>

                
              </div>
            </div>
            
            <div className="mb-3 pl-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Fecha final
              </label>
              <div className="flex">
                <div className="flex items-center justify-center">
                  <div className="datepicker relative form-floating mb-3 xl:w-96">
                    <input
                      onChange={handleOnchangeFechaFinal}
                      value={fechaFinal}
                      type="date"
                      name="dateFinal"
                      className="form-control block w-full px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder="Select a date"
                    />
                  </div>
                </div>

                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          
               
        </form>
        
        <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                    <th></th>
                    <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        Consentimientos Informado
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        Firma
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        Tipo.Doc
                      </th>
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Documento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Nombre Usuario
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Atencion
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                       Consecutivo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Fecha ingreso
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Cama
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Pabellon
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Contrato
                      </th>
                    </tr>
                  </thead>
                  <tbody >
                  {
                    loading?
                    dataConsentimientoInformado.map((item,index)=>(
                        <TablaConsentimientoInformadoPrincipal user={item} key={index} setactualizarData={setactualizarData}/>
                    ))
                    :
                    <tr className="divide-y divide-slate-700 ">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      
                      <td><Loading/></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> 
      </div>
      
      
      
    </>
  )
}

export default PrincipalConsentimientoInformado